module.exports = __webpack_public_path__ + "img/ruckly.900a1411.jpg";